const API_URL = process.env.REACT_APP_API_URL;

class PaymentMethodsService {
  async getPaymentMethods() {
    const response = await fetch(`${API_URL}/payment/methods`, {
      credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to fetch payment methods');
    return response.json();
  }

  async createSetupIntent() {
    const response = await fetch(`${API_URL}/payment/methods/setup-intent`, {
      method: 'POST',
      credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to create setup intent');
    return response.json();
  }

  async deletePaymentMethod(id) {
    const response = await fetch(`${API_URL}/payment/methods/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to delete card');
    return response.json();
  }
}

const paymentMethodsService = new PaymentMethodsService();
export default paymentMethodsService;
